import React from 'react'
import classNames from 'classnames'

export const Heading = (props) => {

  let headingClassNames = [
    'mt-4 mb-6',
    'font-bold',
  ]

  if (props.size) {
    headingClassNames.push({
      h1: 'text-5xl',
      h2: 'text-4xl',
      h3: 'text-3xl',
      h4: 'text-2xl',
      h5: 'text-xl',
    }[props.size])
  }

  return (
    <div className={classNames(headingClassNames)}>
      {props.children}
    </div>
  );
};

export default Heading;